import { Injectable } from '@angular/core';
import { PricingPlan } from '../../shared/models/pricing-plan';

@Injectable({
  providedIn: 'root',
})
export class PackageService {

  private packages: PricingPlan[] = [
    {
      title: 'Documentation-Only Pack',
      price: '€499',
      isVariable: true,
      note: 'Fixed price package',
      features: [
        'ISO 27001 & ISO 42001 policy and procedure templates',
        'Risk assessment and risk register templates',
        'Statement of Applicability (SoA) template',
        'Core ISMS documentation pack',
        'Fully editable Word and Excel formats',
      ],
      cta: 'Get Started',
      route: '/contact-us',
      queryParams: {
        messageType: 'Documentation-Only Pack',
      },
    },
    {
      title: 'ISO 27001 & ISO 42001 Certification Readiness Audit',
      price: 'From €1,499',
      isVariable: true,
      note: 'Depends on scope and audit complexity',
      features: [ 
        'Documentation and control implementation review',
        'Stage 1 and Stage 2 readiness assessment',
        'ISO 27001 & ISO 42001 certification readiness assessment report',
        'Certification roadmap and recommendations',
      ],
      cta: 'Get Started',
      route: '/contact-us',
      queryParams: {
        messageType: 'ISO 27001 and ISO 42001 Certification Readiness Audit',
      },
    },
    {
      title: 'Managed ISMS Implementation Support',
      price: 'From €1,299 / month',
      isVariable: true,
      note: 'Ongoing support based on organisation size',
      features: [
        'Ongoing ISMS advisory support',
        'Risk register and policy updates',
        'Compliance and governance reviews',
        'Internal audit preparation',
        'Certification audit support',
      ],
      cta: 'Get Started',
      route: '/contact-us',
      queryParams: {
        messageType: 'Managed ISMS Implementation Support',
      },
    },
    {
      title: 'ISO 27001 & ISO 42001 Design and Implementation',
      price: 'From €4,999',
      isVariable: true,
      note: 'Full implementation scope dependent',
      features: [
        'End-to-end ISO 27001 & ISO 42001 implementation',
        'ISMS design and documentation',
        'Risk assessment and SoA development',
        'Control implementation guidance',
        'Certification readiness support',
      ],
      cta: 'Get Started',
      route: '/contact-us',
      queryParams: {
        messageType: 'ISO 27001 and ISO 42001 Design and Implementation',
      },
    },
    {
      title: 'ISMS Certification Audit Remediation',
      price: 'From €1,099 / month',
      isVariable: true,
      note: 'Remediation based on audit findings scope',
      features: [
        'Remediation support for audit findings (minor & major non-conformities)',
        'Action plan development, tracking, and corrective actions',
        'Policy, risk register, and SoA updates aligned to findings',
        'Audit-ready documentation and evidence preparation',
        'Ongoing compliance checks and support for surveillance audits',
      ],
      cta: 'Get Started',
      route: '/contact-us',
      queryParams: {
        messageType: 'ISMS Certification Audit Remediation',
      },
    },
    {
      title: 'PECB Certified ISO 27001 and ISO 42001 Training',
      price: 'From €899',
      isVariable: true,
      note: 'Includes multiple ISO/IEC 27001 & ISO/IEC 42001 certification tracks',
      features: [
        'ISO/IEC 27001 & ISO/IEC 42001 Foundation',
        'ISO/IEC 27001 & ISO/IEC 42001 Lead Implementer',
        'ISO/IEC 27001 & ISO/IEC 42001 Lead Auditor',
        'ISO/IEC 27001 & ISO/IEC 42001 Risk Manager',
      ],
      cta: 'Get Started',
      route: '/contact-us',
      queryParams: {
        messageType: 'PECB Certified ISO 27001 & ISO 42001 Training',
      },
    },
  ];

  getAllPackages(): PricingPlan[] {
    return this.packages;
  }
}